import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
const loadNewComponent = () =>
  Promise.all([
    import(/* webpackChunkName: "snp-guidance-tab" */ "./components"),
  ]).then(([importedModule0]) => {
    const component = importedModule0.default;
    return component;
  });
// .catch(err => {
//   throw err;
// });
const updateStore = () => ({
  path: "guidance-documents",
  component: withAsyncRouteLoading(loadNewComponent),
});
export default updateStore;
